<script>
  import { useForm, inertia } from '@inertiajs/svelte';
  import AuthLayout from '../../components/AuthLayout.svelte';
  import Field from '../../components/ui/Field.svelte';
  import Button from '../../components/ui/Button.svelte';

  const form = useForm({ email: '', password: '' });

  let clientErrors = $state({});

  function validate() {
    clientErrors = {};
    if (!form.email.trim()) clientErrors.email = 'Email is required.';
    if (!form.password) clientErrors.password = 'Password is required.';
    return Object.keys(clientErrors).length === 0;
  }

  function submit() {
    if (!validate()) return;
    // Rodauth handles POST /auth/login; redirects to / on success.
    form.post('/auth/login');
  }
</script>

<AuthLayout title="Sign in">
  <form onsubmit={(e) => { e.preventDefault(); submit(); }} class="flex flex-col gap-4" novalidate>
    <Field label="Email" id="email" error={clientErrors.email || form.errors.email}>
      {#snippet children(describedBy)}
        <input id="email" type="email" class="input" bind:value={form.email} autocomplete="email" aria-describedby={describedBy} />
      {/snippet}
    </Field>
    <Field label="Password" id="password" error={clientErrors.password || form.errors.password}>
      {#snippet children(describedBy)}
        <input id="password" type="password" class="input" bind:value={form.password} autocomplete="current-password" aria-describedby={describedBy} />
      {/snippet}
    </Field>
    <Button type="submit" disabled={form.processing}>
      {form.processing ? 'Signing in…' : 'Sign in'}
    </Button>
  </form>

  <p class="text-sm text-secondary-500 text-center mt-6">
    No account? <a use:inertia href="/signup" class="text-primary-600 font-medium">Create one</a>
  </p>
</AuthLayout>
